import React, { useState } from 'react';
import Icon from '../AppIcon';

const ContactQuickAccess = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hola, me interesa obtener información sobre sus servicios de limpieza de piscinas.');
    window.open(`https://wa.me/50622534791?text=${message}`, '_blank');
  };

  const handlePhoneClick = () => {
    window.location.href = 'tel:+50622534791';
  };

  return (
    <div className="fixed bottom-6 right-6 z-900">
      {/* Expanded Contact Options */}
      {isExpanded && (
        <div className="mb-4 space-y-2">
          <button
            onClick={handleWhatsAppClick}
            className="flex items-center space-x-3 bg-success text-white px-4 py-3 rounded-lg shadow-medium hover:bg-success/90 nav-transition w-full"
          >
            <Icon name="MessageCircle" size={20} />
            <span className="font-medium">WhatsApp</span>
          </button>
          <button
            onClick={handlePhoneClick}
            className="flex items-center space-x-3 bg-primary text-white px-4 py-3 rounded-lg shadow-medium hover:bg-primary/90 nav-transition w-full"
          >
            <Icon name="Phone" size={20} />
            <span className="font-medium">Llamar</span>
          </button>
        </div>
      )}

      {/* Main Toggle Button */}
      <button
        onClick={toggleExpanded}
        className="bg-accent text-white p-4 rounded-full shadow-large hover:bg-accent/90 nav-transition"
        aria-label="Contact options"
      >
        <Icon name={isExpanded ? "X" : "Phone"} size={24} />
      </button>
    </div>
  );
};

export default ContactQuickAccess;